module.exports = __webpack_public_path__ + "images/emoji/heart_decoration.3322a3fe552d62966a33.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/heart_decoration.png
// module id = 9rdi
// module chunks = 24